<template>
    <div class="news-detail">
        <div class="banner-box">
            <img src="./../assets/img/banner_news.jpg" alt="">
        </div>
        <div class="detail-box" v-if="articleDetail">
            <h3 class="detail-title">{{articleDetail.title}}</h3>
            <p class="detail-info"><span>来源：{{articleDetail.nSource}}</span> <span>{{articleDetail.create_time}}</span> </p>
            <div class="article-cont" v-html="articleDetail.content" ref="article"></div>
        </div>
    </div>
</template>
<script>
export default {
  name: "newsdetail",
  data() {
    let id = this.$route.params.id;

    return {
      id,
      articleDetail: null
    };
  },

  methods: {
    // /api/article/articleDetail
    getarticl() {
      this.$http.get("/api/article/articleDetail?id=" + this.id).then(res => {
        if (res.code == 1) {
          this.articleDetail = res.data;

          setTimeout(() => {
            let aimg = this.$refs.article.getElementsByTagName("img");
            Array.from(aimg).forEach(item => {
              item.style.height = "auto";
            });
          });
        }
      });
    }
  },
  mounted() {
    this.getarticl();
  }
};
</script>
<style lang="scss">
.news-detail {
  .detail-box {
    margin-top: 0.2rem;
    padding: $padding;
    font-size: 0.24rem;
    img {
      max-width: 100%;
    }
    .detail-title {
      text-align: center;
      font-size: 0.3rem;
      margin-bottom: 0.15rem;
    }
    .detail-info {
      @extend .flex;
      justify-content: space-between;
      font-size: 0.2rem;
      color: $fontColor;
      margin-bottom: 0.5rem;
      padding-bottom:.2rem;
      border-bottom:.02rem solid $fontColor;
    }
  }
}
</style>

